import { toString } from "currency";
import { Link } from "expo-router";
import { View } from "react-native";
import { Avatar, Icon, Text, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";
import { CartReview } from "ui/merchant";

import Disclaimer from "@/src/components/disclaimer";
import Title from "@/src/components/typography/title";
import useDeliveryStatus from "@/src/contexts/delivery-status-context";

export default function DetailsScreen() {
  const { deliveryStatus } = useDeliveryStatus();
  const tailwind = useTailwind();

  if (!deliveryStatus) return null;

  return (
    <View style={tailwind("p-4 gap-4")}>
      <Header />
      <OrderDetails />
      <Disclaimer />
    </View>
  );
}

export function OrderDetails() {
  const { deliveryStatus } = useDeliveryStatus();

  if (!deliveryStatus) return null;

  const { currency } = deliveryStatus.order.cart.items[0];

  const total = toString({ amount: deliveryStatus.order.total, currency });

  const itemsTotal = toString({
    amount: deliveryStatus.order.cart.items_total,
    currency,
  });

  // TODO: remove `?` as it should never be undefined. need to fix BE
  const fulfillmentTotal = deliveryStatus.order.fulfillment_option
    ? toString({
        amount: deliveryStatus.order.fulfillment_option.price,
        currency,
      })
    : null;

  const discountTotal = deliveryStatus.order.cart.discount_amount
    ? toString({ amount: -deliveryStatus.order.cart.discount_amount, currency })
    : null;

  return (
    <CartReview.Card
      products={deliveryStatus.order.cart.items}
      footer={
        <>
          <CartReview.Line label="Subtotal" value={itemsTotal} />
          {deliveryStatus.order.fulfillment_option && fulfillmentTotal && (
            <CartReview.Line
              label={`Envío ${deliveryStatus.order.fulfillment_option.description}`}
              value={fulfillmentTotal}
            />
          )}
          {deliveryStatus.order.cart.discount && discountTotal && (
            <CartReview.Line
              label={`${deliveryStatus.order.cart.discount.code} (-${deliveryStatus.order.cart.discount.percentage}%)`}
              value={discountTotal}
            />
          )}

          <CartReview.Line label="Total" value={total} bold />
        </>
      }
    />
  );
}

function Header() {
  const tailwind = useTailwind();
  const { colors } = useTheme();

  const { deliveryStatus } = useDeliveryStatus();

  if (!deliveryStatus) return null;

  const { simple_id } = deliveryStatus.order;

  const details = `Detalles de pedido${simple_id ? ` #${simple_id}` : ""}`;

  return (
    <View style={tailwind("gap-3")}>
      <Link
        asChild
        href={{
          pathname: "/[uuid]/",
          params: { uuid: deliveryStatus.order.uuid },
        }}
      >
        <View style={tailwind("flex-row items-center gap-2")}>
          <Icon source="arrow-left" size={24} />
          <Title text={details} />
        </View>
      </Link>
      <View style={tailwind("flex-row items-center gap-2")}>
        <Avatar.Image
          source={{ uri: deliveryStatus.order.merchant.avatar_url }}
          size={50}
        />
        <Text variant="labelLarge" style={{ color: colors.onSurfaceVariant }}>
          {deliveryStatus.order.merchant.name}
        </Text>
      </View>
    </View>
  );
}
